import React, { useState } from 'react';
import classNames from 'classnames';
import useLoggedInUser from '../../utils/useLoggedInUser';
import styles from './DuplicateNavbar.module.css';
import sharedStyles from '../../styles/Shared.module.css';
import SidebarItem from '../SidebarItem';
import LogoutButton from '../LogoutButton';
import {
  LANDING_URL, LOGO_URL, SOURCE_STORAGE_KEY,
} from '../../constants';
import Logo from '../../sharedComponents/Logo';
import ButtonBlack from '../../sharedComponents/Button/ButtonBlack';
import Dropdown from '../Dropdown';
import { SelectSpaceOption } from '../SelectSpaceOption';
import LoginPopup from '../LoginPopup';
import Overlay from '../Overlay';

function DuplicateNavbar({
  spaceName, pageName, pageID, onDuplicate, disabled,
}: {
  spaceName: string,
  pageName: string,
  pageID: string,
  onDuplicate: (create: boolean, spaceID: string) => void,
  disabled: boolean,
}) {
  const [menuOpen, setmenuOpen] = useState(false);
  const { user, checkUserLogin } = useLoggedInUser();
  const [openLogin, setopenLogin] = useState(false);

  const triggerOnClick = () => {
    // if user is not recorded in local storage, then noone is logged in
    if (!user) {
      localStorage?.setItem(
        SOURCE_STORAGE_KEY,
        `duplicate_page:${pageID}`,
      );
      setopenLogin(true);
    }
  };
  const onSuccess = async () => {
    setopenLogin(false);
    checkUserLogin();
  };
  return (
    <>
      {menuOpen && <Overlay onClick={() => setmenuOpen(false)} />}
      <div className={styles.navbar}>
        <div className={styles.section}>
          <div className="is-size-6 with-text-color">
            {spaceName}
          </div>
          {pageName
            && (
              <div className="is-size-6 with-lighter-text-color">
                {pageName}
              </div>
            )}
        </div>
        <div className={styles.section}>
          <Dropdown
            open={menuOpen}
            setopen={disabled || !user ? () => null : setmenuOpen}
            width={240}
            right
            trigger={
              <ButtonBlack disabled={disabled}>Duplicate</ButtonBlack>
            }
            triggerClassname={classNames(styles.zOnTop, 'p-0')}
            contentClassname={styles.zOnTop}
            triggerOnClick={triggerOnClick}
            content={(
              <div className={styles.dropdownContainer}>
                <div
                  className={classNames(
                    'is-subtitle',
                    'pl-2',
                  )}
                >
                  Choose a site
                </div>
                {user?.id
                && <SelectSpaceOption onClick={onDuplicate} />}
                <hr className={classNames('dropdown-divider', sharedStyles.hr)} />
                <SidebarItem disabled center={`${user?.email}`} />
                <SidebarItem
                  center={(
                    <LogoutButton className="with-light-text-color">
                      Logout
                    </LogoutButton>
                  )}
                  className="with-light-text-color"
                />
              </div>
            )}
          />
          <div className="is-subtitle mr-1">|</div>
          <div className="is-flex is-align-items-center is-justify-content-flex-end">
            <a href={LANDING_URL} className="is-flex is-align-items-center is-justify-content-flex-end">
              <Logo logoURL={LOGO_URL} link={LANDING_URL} width={30} height={30} />
              <div className="ml-2 is-subtitle-size with-text-color has-text-weight-bold">typedream</div>
            </a>
          </div>
        </div>
      </div>
      <LoginPopup open={openLogin} setopen={setopenLogin} onSuccess={onSuccess} />
    </>
  );
}
export default DuplicateNavbar;
